import { registerEnum } from '@cbbt/lib-interface';
var OnboardingCommonProductType;
(function (OnboardingCommonProductType) {
    OnboardingCommonProductType["BUSINESS_ACCOUNT"] = "BA";
    OnboardingCommonProductType["COMMUNITY_ACCOUNT"] = "CA";
})(OnboardingCommonProductType || (OnboardingCommonProductType = {}));
registerEnum(OnboardingCommonProductType, 'OnbProductTypes');
export { OnboardingCommonProductType };
//# sourceMappingURL=OnboardingCommonProductType.js.map